import { render, staticRenderFns } from "./BlockAccordions.vue?vue&type=template&id=30cce728&scoped=true&"
import script from "./BlockAccordions.vue?vue&type=script&lang=js&"
export * from "./BlockAccordions.vue?vue&type=script&lang=js&"
import style0 from "./BlockAccordions.vue?vue&type=style&index=0&id=30cce728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cce728",
  null
  
)

export default component.exports